module.exports = __webpack_public_path__ + "static/SiteGrid-f2a41ee168052bf9bbaab818e48b207b.jpg";